require('videos_anchor_header_fix')
require('feedbacks')

Us = LP.module 'Us'

Us.videos = ->
  new LP.VideosAnchorHeaderFix().init()

  $vimeoModal = $('#vimeo-modal-video')
  if $vimeoModal.length
    $vimeoModal.modal('show')
    `import(/* webpackChunkName: 'vimeo-player' */ '@vimeo/player')`.then((module) ->
      player = new module.default($('#vimeo-player')[0])
      $vimeoModal.on 'hidden.bs.modal', ->
        player.pause()
      player.play()
    )
